import { render, staticRenderFns } from "./SiteDocumentNewForm.vue?vue&type=template&id=f2f216c6"
import script from "./SiteDocumentNewForm.vue?vue&type=script&lang=js"
export * from "./SiteDocumentNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports